export const recruitmentGettingStartedArticle = {
  title: 'Recruitment & ATS: Getting Started',
  slug: 'recruitment-getting-started',
  content: `Recruitment & ATS: Getting Started

Run hiring workflows from job posting to offers.

1) Open Recruitment
- Go to /recruitment.
- Tabs use URL hashes (#dashboard, #jobs, #pipeline, #applications, #candidates, #analytics, #embed).

2) Post jobs
- Click “Post Job” to open the job form.

3) Manage pipeline
- Use Pipeline to move candidates through stages.

4) Track candidates
- Applications and Talent Pool list candidate activity.

5) Embed portal
- Embed Portal provides code for careers pages.
`,
};
